import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const FormSubmitButton = (props) => {

  let {
    onClick,
    loading,
  } = props;

  return (
    <Button className={'form-submit-button'}
            disabled={loading}
            onClick={onClick}>{loading? <i className="fa fa-spinner fa-spin"></i> : 'お問い合わせを送信する'}</Button>
  );

};

FormSubmitButton.propTypes = {
  onClick: PropTypes.func,
};

export default FormSubmitButton;
